import {useDispatch, useSelector} from 'react-redux'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import ModalConfirmClose from '../../../../components/Modals/Generales/ModalConfirmClose'
import ModalDelete from '../../../../components/Modals/Generales/ModalDelete'
import ModalSignacionSucursales from './ModalSignacionSucursales'
import {State} from '../../../../reducers'
import {
  gu_lu_OpenModalAceptarRechazar,
  gu_lu_OpenModalEliminarUsuario,
  gu_lu_OpenModalResetPassword,
  gu_lu_OpenModalSucursales,
  gu_lu_SetUsuarioSeleccionado,
  gu_lu_generarPDF,
} from '../../../../actions/gestion-usuario/lista-usuario/listaUsuario.actions'
import {bindActionCreators} from 'redux'
import {actionsGUListarUsuarios} from '../../../../actions/action-creators'
import { ModalPrint } from './ModalPrint'

const ModalsControls = () => {
  const {activeAceptarRechazar, activeSucursales, activePassword, activeEliminar, activePrint, activeEstatus} = useSelector(
    (state: State) => state.gestionUsuario.listarUsuarios.modales
  )
  const {usuarioSeleccionado} = useSelector(
    (state: State) => state.gestionUsuario.listarUsuarios
  )
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUListarUsuarios, dispatch)

  const openModalSucursales = () => {
    dispatch(gu_lu_OpenModalSucursales(true))
    dispatch(gu_lu_OpenModalAceptarRechazar(false))
  }

  const closeModalAceptarRechazar = () => {
    dispatch(gu_lu_OpenModalAceptarRechazar(false))
    dispatch(gu_lu_SetUsuarioSeleccionado(null))
  }

  const closeModalResetPassword = () => {
    dispatch(gu_lu_OpenModalResetPassword(false))
    dispatch(gu_lu_SetUsuarioSeleccionado(null))
  }

  const closeModalEliminar = () => {
    dispatch(gu_lu_OpenModalEliminarUsuario(false))
    dispatch(gu_lu_SetUsuarioSeleccionado(null))
  }

  return (
    <>
      {activeAceptarRechazar && (
        <ModalConfirmClose
          title='Aceptar Usuario'
          detail='¿Deseas aceptar la solicitud de este usuario?'
          messageAction='Aceptar solicitud'
          actionConfirm={openModalSucursales}
          messageClose='Rechazar'
          closeModalConfirm={actions.gu_lu_RechazarSolicitudUsuario}
          closeModal={closeModalAceptarRechazar}
          Styles={{minWidth: '25%', maxWidth: '550px'}}
        />
      )}
      {activeSucursales && <ModalSignacionSucursales />}
      {activePassword && (
        <ModalConfirm
          title='Reiniciar Contraseña'
          detail='Se enviará un enlace/código al correo del usuario seleccionado para reiniciar su contraseña.'
          messageAction='Restablecer contraseña'
          actionConfirm={actions.gu_lu_ResetPasswordConfirm}
          closeModalConfirm={closeModalResetPassword}
          Styles={{minWidth: '25%', maxWidth: '550px'}}
        />
      )}
      {activeEliminar && (
        <ModalDelete
          title='Eliminar usuario'
          detail='¿Seguro que quieres eliminar a este usuario? Esta acción no se puede deshacer.'
          messageAction='Eliminar'
          actionDelete={actions.gu_lu_EliminarUsuarioConfirm}
          closeModalDelete={closeModalEliminar}
          Styles={{minWidth: '25%', maxWidth: '700px'}}
        />
      )}
      {activePrint &&
        <ModalPrint 
          dataCliente={usuarioSeleccionado} 
          closeModalPrint = {() => actions.gu_lu_OpenModalPrint(false)} 
          actionConfirm = {() => actions.gu_lu_generarPDF()}
        />
      }
      {
        activeEstatus && 
        (
          <ModalConfirm 
            title={`${usuarioSeleccionado.accionEstatus ? 'Activar' : 'Desactivar'} usuario`}
            detail={
              `¿Seguro que quieres realizar esta acción?`
            }
            actionConfirm={() => actions.gu_lu_changeEstatus()}
            closeModalConfirm={() => actions.gu_lu_OpenModalEstatus(false)}
            />
        )
      }
    </>
  )
}

export default ModalsControls
